import { createRouter, createWebHashHistory } from "vue-router";
//import App from "./App.vue";
const routes = [
  {
    path: "/",
    name: "app",
    component: () => import("./pages/App.vue"),
  },
  {
    path: "/search",
    name: "search",
    component: () => import("./pages/main/Home.vue"),
  },
  /*
  {
    path: "/recoverPassword",
    name: "recoverPassword",
    component: () => import("./pages/users/UserRecoverPasswordView.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "not-found",
    component: () => import("./pages/not_found/NotFound.vue"),
  },
  {
    path: "/access-denied",
    name: "access-denied",
    component: () => import("./pages/not_found/AccessDenied.vue"),
  },*/
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
/*
function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    let [key, value] = cookie.split("=");
    if (key === name) return value;
  }
  return null; // Retorna null se o cookie não for encontrado
}
*/  

/*
router.beforeEach((to, from, next) => {
  //next(); // Permite a navegação
  const local = localStorage.getItem('local');
  const token = localStorage.getItem('token');

  // Verifica se não há "local" ou "token" e a rota não é "login", "recoverPassword" ou "not-found"
  if ((!local || !token) && to.name !== 'login' && to.name !== 'recoverPassword' && to.name !== 'not-found') {
    if (to.name !== 'app') {
      next({ name: 'app' }); // Redireciona para a página principal
    } else {
      next(); // Permite a navegação para a página principal
    }
  } else {
    next(); // Permite a navegação
  }
});
*/

export default router;